import { css } from '@/styled-system/css';
import { cva } from '@/styled-system/css/cva.mjs';

export const bannerBoxRecipe = cva({
  base: {
    marginBlock: '400',
    marginInline: 'auto',
    boxSizing: 'content-box',
  },
  variants: {
    isEnterpriseCustomer: {
      true: {},
      false: {
        // Non-enterprise view has banners outside of Page.Content, so we need to duplicate spacing
        // oxlint-disable-next-line constellation/no-raw-spacing-values -- `maxWidth: 1280px` is past the end of the numeric sizes scale, which stops at `5000` (200px)
        maxWidth: '1280px',
        paddingInline: {
          base: 'device.margin.mobile',
          md: 'device.margin.tablet',
          xl: 'device.margin.desktop',
        },
      },
    },
  },
});

export const stickyLeftCellRecipe = cva({
  base: {
    position: { base: 'relative', lg: 'sticky' },
    left: { base: 'auto', lg: 0 },
    zIndex: 2,
    transition: 'box-shadow 0.2s',
    boxSizing: 'border-box',
  },
  variants: {
    scrolled: {
      true: {
        boxShadow: '2px 4px 8px 0px rgba(0, 0, 0, {opacity.15})',
        borderRight: '2px solid {colors.border.muted-alt}',
      },
    },
  },
});

export const tableCellHoverStyles = css.raw({
  transition: 'background-color 0.1s ease-out',

  // When the parent tr is being hovered, the cell should be highlighted
  'tbody > *:hover tr &': {
    backgroundColor: 'bg.action.neutral.alt.hover',
  },
});

export const fixedScrollbarStyles = css.raw({
  position: 'fixed',
  bottom: 0,
  zIndex: 3,
  overflowX: 'auto',
  display: 'block',
});
